import { HOME_HERO } from '@/dictionary/home';
import { HOME_ANCHORS } from '@/dictionary/routes';
import { HERO_POSTER_URL, LOGO_URL } from '@/config/assets';
import heroVideoUrl from '/assets/hero-video.mp4';
import classes from './HeroSection.module.css';

export function HeroSection() {
  return (
    <section className={classes.hero} id={HOME_ANCHORS.top.slice(1)}>
      <div className={classes.background}>
        {/* poster מוצג עד שהווידאו (10.7MB) נטען, וגם כשאוטו-פליי חסום */}
        <video
          src={heroVideoUrl}
          poster={HERO_POSTER_URL}
          autoPlay
          muted
          loop
          playsInline
          preload="auto"
          aria-hidden="true"
        />
      </div>
      <div className={classes.veil} />
      <div className={classes.content}>
        <img src={LOGO_URL} alt={HOME_HERO.logoAlt} className={classes.logo} />
        <p className={classes.tagline}>
          <strong>{HOME_HERO.tagline}</strong>
        </p>
      </div>
    </section>
  );
}
